import React from "react";
import $ from "jquery";
import SignUp from "./Demo/Authentication/SignUp/SignUp";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

// const SignUp1 = React.lazy(() =>
//   import("./Demo/Authentication/SignUp/SignUp1")
// );
// const Signin1 = React.lazy(() => import("./Demo/Authentication/SignIn/SignIn"));
// const DashboardDefault = React.lazy(() => import("./Demo/Dashboard/Default"));
// const CampaignManage = React.lazy(() =>
//   import("./Demo/Dashboard/CampaignManage")
// );
// const CampaignView = React.lazy(() => import("./Demo/Dashboard/CampaignView"));
// const CommunityAdd = React.lazy(() => import("./Demo/Dashboard/CommunityAdd"));
// const CommunityView = React.lazy(() =>
//   import("./Demo/Dashboard/CommunityView")
// );

//라우터 설정 커스텀//
// const Signup = React.lazy(() => import("./Demo/Authentication/SignUp/SignUp"));
// const SignIn = React.lazy(() => import("./Demo/Authentication/SignIn/SignIn"));
const Dashboard = React.lazy(() => import("./Demo/Custom/Dashboard/Dashboard"));
const UserList = React.lazy(() =>
  import("./Demo/Custom/Manage_Users/UserList")
);
const UserReportsList = React.lazy(() =>
  import("./Demo/Custom/Manage_Users/UserReportsList")
);
const ManagePushNotifications = React.lazy(() =>
  import("./Demo/Custom/Manage_Push_Notifications/ManagePushNotifications")
);

const CustomerSupportNotice = React.lazy(() =>
  import("./Demo/Custom/CustomerSupport/Notice")
);
const CustomerSupportQuestion = React.lazy(() =>
  import("./Demo/Custom/CustomerSupport/Question")
);
const CustomerSupportFAQ = React.lazy(() =>
  import("./Demo/Custom/CustomerSupport/FAQ")
);

const TermsofService = React.lazy(() =>
  import("./Demo/Custom/TermsPrivacy/TermsofService")
);

const PersonalInfoCollection = React.lazy(() =>
  import("./Demo/Custom/TermsPrivacy/PersonalInfoCollection")
);

const AdministratorList = React.lazy(() =>
  import("./Demo/Custom/ManageAdministrator/AdministratorList")
);

const ManageGroup = React.lazy(() =>
  import("./Demo/Custom/ManageAdministrator/ManageGroup")
);

const CommonCode = React.lazy(() =>
  import("./Demo/Custom/Common_Code/CommonCode.js")
);

//Pay

const ManagePayments = React.lazy(() =>
  import("./Demo/Custom/Manage_Payments/ManagePayments.js")
);
const ManagePaymentMaster = React.lazy(() =>
  import("./Demo/Custom/Manage_Payments/ManagePaymentMaster.js")
);
const ManageRefundRequest = React.lazy(() =>
  import("./Demo/Custom/ManageRefundRequest/ManageRefundRequest.js")
);

const Points = React.lazy(() =>
  import("./Demo/Custom/Manage_Points/Points.js")
);
const Cards = React.lazy(() => import("./Demo/Custom/Manage_Points/Cards.js"));

const ManageMenu = React.lazy(() =>
  import("./Demo/Custom/ManageMenu/ManageMenu.js")
);

const ChargeStandbyManagement = React.lazy(() =>
  import("./Demo/Custom/ChargeStandbyManagement/ChargeStandbyManagement.js")
);

const ManageAffiliateStore = React.lazy(() =>
  import("./Demo/Custom/Manage_Affiliate_Store/Manage_Affiliate_Store.js")
);

const UIBasicButton = React.lazy(() =>
  import("./Demo/UIElements/Basic/Button")
);
const UIBasicBadges = React.lazy(() =>
  import("./Demo/UIElements/Basic/Badges")
);
const UIBasicBreadcrumbPagination = React.lazy(() =>
  import("./Demo/UIElements/Basic/BreadcrumbPagination")
);

const UIBasicCollapse = React.lazy(() =>
  import("./Demo/UIElements/Basic/Collapse")
);
const UIBasicTabsPills = React.lazy(() =>
  import("./Demo/UIElements/Basic/TabsPills")
);
const UIBasicBasicTypography = React.lazy(() =>
  import("./Demo/UIElements/Basic/Typography")
);

const FormsElements = React.lazy(() => import("./Demo/Forms/FormsElements"));

const BootstrapTable = React.lazy(() => import("./Demo/Tables/BootstrapTable"));

const Nvd3Chart = React.lazy(() => import("./Demo/Charts/Nvd3Chart/index"));

const GoogleMap = React.lazy(() => import("./Demo/Maps/GoogleMap/index"));

const OtherSamplePage = React.lazy(() => import("./Demo/Other/SamplePage"));
const OtherDocs = React.lazy(() => import("./Demo/Other/Docs"));

var routes = [
  // 라우터 설정 커스텀

  //로그인 화면
  // {
  //   path: "/auth/SignUp",
  //   exact: true,
  //   name: "Default",
  //   component: Signup,
  // },
  // {
  //   path: "/",
  //   exact: true,
  //   name: "Default",
  //   component: SignIn,
  // },
  //

  {
    path: "/Dashboard/Dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/Manage_Users/UserList",
    exact: true,
    name: "Manage Users",
    component: UserList,
  },
  {
    path: "/Report/AngkoPayUserReportsList",
    exact: true,
    name: "Manage Report",
    component: UserReportsList,
  },
  {
    path: "/Manage_Push_Notifications/ManagePushNotifications",
    exact: true,
    name: "Manage Push Notifications",
    component: ManagePushNotifications,
  },
  {
    path: "/Customer_Support/Notice",
    exact: true,
    name: "Notice",
    component: CustomerSupportNotice,
  },
  {
    path: "/Customer_Support/Question",
    exact: true,
    name: "1:1 Question",
    component: CustomerSupportQuestion,
  },
  {
    path: "/Customer_Support/FAQ",
    exact: true,
    name: "FAQ",
    component: CustomerSupportFAQ,
  },
  {
    path: "Terms_Privacy/Terms_of_Service",
    exact: true,
    name: "Terms of Service",
    component: TermsofService,
  },
  {
    path: "/Terms_Privacy/Personal_Info_Collection_Usage",
    exact: true,
    name: "Personal Information Collection",
    component: PersonalInfoCollection,
  },
  {
    path: "/Manage_Administrator/Administrator_List",
    exact: true,
    name: "Administrator List",
    component: AdministratorList,
  },
  {
    path: "/Manage_Administrator/Manage_Group",
    exact: true,
    name: "Manage Group",
    component: ManageGroup,
  },

  {
    path: "/Common_code/Common_code",
    exact: true,
    name: "Common Code",
    component: CommonCode,
  },

  // Pay
  {
    path: "/Manage_Payments/ManagePayments",
    exact: true,
    name: "Payments",
    component: ManagePayments,
  },
  {
    path: "/Manage_Payments/ManagePaymentMaster",
    exact: true,
    name: "Payments Master",
    component: ManagePaymentMaster,
  },
  {
    path: "/Manage_Refund_Request/ManageRefundRequest",
    exact: true,
    name: "Manage Refund Request",
    component: ManageRefundRequest,
  },

  {
    path: "/Manage_Points/Points",
    exact: true,
    name: "Points",
    component: Points,
  },
  {
    path: "/Manage_Points/Cards",
    exact: true,
    name: "Debt/Credit card",
    component: Cards,
  },

  {
    path: "/Manage_Menu/ManageMenu",
    exact: true,
    name: "Manage Menu",
    component: ManageMenu,
  },
  {
    path: "/ChargeStandbyManagement/ChargeStandbyManagement",
    exact: true,
    name: "Manage Charge",
    component: ChargeStandbyManagement,
  },
  {
    path: "/ManageAffiliateStore/ManageAffiliateStore",
    exact: true,
    name: "Manage Affiliate Store",
    component: ManageAffiliateStore,
  },

  {
    path: "/basic/button",
    exact: true,
    name: "Basic Button",
    component: UIBasicButton,
  },
  {
    path: "/basic/badges",
    exact: true,
    name: "Basic Badges",
    component: UIBasicBadges,
  },
  {
    path: "/basic/breadcrumb-paging",
    exact: true,
    name: "Basic Breadcrumb Pagination",
    component: UIBasicBreadcrumbPagination,
  },
  {
    path: "/basic/collapse",
    exact: true,
    name: "Basic Collapse",
    component: UIBasicCollapse,
  },
  {
    path: "/basic/tabs-pills",
    exact: true,
    name: "Basic Tabs & Pills",
    component: UIBasicTabsPills,
  },
  {
    path: "/basic/typography",
    exact: true,
    name: "Basic Typography",
    component: UIBasicBasicTypography,
  },
  {
    path: "/forms/form-basic",
    exact: true,
    name: "Forms Elements",
    component: FormsElements,
  },
  {
    path: "/tables/bootstrap",
    exact: true,
    name: "Bootstrap Table",
    component: BootstrapTable,
  },
  {
    path: "/charts/nvd3",
    exact: true,
    name: "Nvd3 Chart",
    component: Nvd3Chart,
  },
  {
    path: "/maps/google-map",
    exact: true,
    name: "Google Map",
    component: GoogleMap,
  },
  {
    path: "/sample-page",
    exact: true,
    name: "Sample Page",
    component: OtherSamplePage,
  },
  { path: "/docs", exact: true, name: "Documentation", component: OtherDocs },
  // { path: "/auth/SignUp", exact: true, name: "Signup", component: SignUp },
  // { path: "/", exact: true, name: "Signin", component: SignIn },
];

export default routes;
